export default "__VITE_PUBLIC_ASSET__81088587__"